import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UsuarioFabricaService } from '../usuario-fabrica-service/usuario-fabrica.service';
import { CrudBase } from './../../../shared/crud/CrudBase';
import { ListitemBuilder } from './../../../shared/dropdown-list/ListItemBuilder';
import { Parametro } from './../../../shared/service-base/parametro';
import { Estado } from './../../../shared/shared/estado.enum';

@Component({
  selector: 'app-usuario-fabrica-cadastro',
  templateUrl: './usuario-fabrica-cadastro.component.html',
  styleUrls: ['./usuario-fabrica-cadastro.component.css']
})
export class UsuarioFabricaCadastroComponent
  extends CrudBase
  implements OnInit {

  modalTexto: string = 'Selecione os Dealers';
  modelOriginal: any = {};

  filtros: any = {};
  itensAtivo: any;
  itensFuncao: any;
  display: boolean = false;
  idDealerSelecionado: number = 0;
  dealers: any[] = [];
  selecionados: any[] = [];
  dealersSelecionados: any[] = [];
  @Output() resetaEstado: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    service: UsuarioFabricaService,
    toastr: ToastrService,
    private servico: UsuarioFabricaService

  ) {
    super(service, toastr);
    this.carregarAtivo();
    this.carregarFiltroVazio();
  }

  ngOnInit() {
    if (!this.model || Object.keys(this.model).length === 0) {
      this.model = {};
      this.dealersSelecionados = [];
    } else {
      this.modelOriginal = this.model;
      this.filtros.dealer = this.model.nivel;
      this.dealersSelecionados = this.model.dealers;
    }

    this.defineModelVazio();
    this.carregarDealers();
  }

  showDialog(id: number) {
    this.display = true;
    this.idDealerSelecionado = id;
  }

  hideDialog() {
    this.display = false;
  }
  get habilitarExclusao(): boolean {
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser') || '{}');

  const usuario = currentUser && currentUser.username
    ? currentUser.username.toString().trim().toLowerCase()
    : '';

  return usuario === 'admin';
}
excluir() {
  if (!this.habilitarExclusao) {
    this.toastr.warning('Somente o usuário ADMIN pode excluir acessos.', 'Atenção');
    return;
  }

  super.excluir();
}

  carregarDealers() {
    this.servico.getFiltroDealers()
      .then(selecionados => {
        this.selecionados = selecionados.filtros;
        this.dealersSelecionados = this.selecionados.filter(dealer => this.dealersSelecionados.includes(dealer.id));
        const dealerRestantes = this.dealersSelecionados.map(dealer => dealer.id).join(',');
        this.servico.getDealersRestantes(dealerRestantes).then(restantes => {this.dealers = restantes.filtros;})
      })
      .catch(error => this.tratarErro('Não foi possível buscar categorias.', 'Erro', <any>error));
  }

  adicionarTipoCategoria(dealer) {
    const index = this.dealers.findIndex(el => el == dealer);
    this.dealers.splice(index, 1);

    this.dealersSelecionados.push(dealer);
  }

  removerDealer(dealer) {
    if (this.state !== Estado.view) {
      const index = this.dealersSelecionados.findIndex(el => el == dealer);
      this.dealersSelecionados.splice(index, 1);
    }
  }

  exibirSucesso(mensagem: string, titulo: string) {
    this.toastr.success(mensagem, titulo);
  }

  filtroDealer(event) {
    this.filtros.dealer = event.target.value;
  }

  carregarFiltroVazio() {
    this.filtros.dealers = null
  }

  private carregarAtivo() {
    this.itensAtivo =
      new ListitemBuilder()
        .add(true, 'Ativo')
        .add(false, 'Inativo')
        .build();
  }

  novo() {
    super.novo();
    this.defineModelVazio();
  }

  private defineModelVazio() {
    if (this.state === Estado.insert) {
      this.model.id = null;
      this.model.funcao = '';
      this.model.ativo = '';
      this.model.nivel = '';
    }
  }

  mensagemSucesso() {
    if (this.state === Estado.insert) {
      const mensagem = 'Novo usuário incluído. \n Um e-mail para definição de senha foi enviado para '.concat(this.model.email).concat('.');
      this.toastr.success(mensagem, 'Usuário criado');
    } else {
      this.toastr.success('Salvo com sucesso!', 'Usuário atualizado');
    }
  }

  salvarComValidacao(event: any) {
    if (this.model.senha !== this.model.senha_confirmada) {
      this.toastr.warning('Confirmação de senha inválida!', 'Validação');
      return;
    }
    if (this.filtros.dealer == 3) {
      if (this.dealersSelecionados.length > 0) {
        this.model.dealers = this.dealersSelecionados.map(e => e.id);
      } else {
        this.toastr.warning('Favor Adicionar o(s) Dealer(s)!', 'Validação');
        return;
      }
    }

    super.salvar();
  }

  public solicitarRedefinicaoSenha() {
    if (!this.model.email) {
      this.toastr.warning('E-mail do usuário não informado no cadastro.', 'Validação');
      return;
    }

    const params: Parametro[] = [];

    params.push(new Parametro('rota', 'redefinir_senha'));
    params.push(new Parametro('id', this.model.id));

    this.service.get(params)
      .then(() => {
        const mensagem = `Alteração de senha solicitada. \n Um e-mail para definição de senha foi enviado para ${this.model.email}.`;
        this.toastr.success(mensagem, 'Solicitação enviada');
      })
      .catch(error => {
        this.tratarErro('Não foi possível solictar redefinição de senha', 'Solicitação não enviada', error);
      });
  }
}
